import { render, staticRenderFns } from "./GroupsModerationScreen.vue?vue&type=template&id=09b00b2f&scoped=true"
import script from "./GroupsModerationScreen.vue?vue&type=script&lang=js"
export * from "./GroupsModerationScreen.vue?vue&type=script&lang=js"
import style0 from "./GroupsModerationScreen.vue?vue&type=style&index=0&id=09b00b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b00b2f",
  null
  
)

export default component.exports